"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deHyphenate = exports.hyphenate = exports.filterByFeatured = void 0;
require("core-js/modules/es6.regexp.split");
exports.filterByFeatured = function filterByFeatured(array) {
    return array.filter(function (a) {
        return a.featured === true;
    });
};
exports.hyphenate = function hyphenate(str) {
    return str.split(' ').join('-').toLowerCase();
};
exports.deHyphenate = function deHyphenate(str) {
    return str.split('-').map(function (s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(' ');
};
